/**
 * Asynchronously resolves and returns the formatted player profile URL.
 *
 * @param {object} player - Player object containing flat or nested names.
 * @param {string|number} clubId - Current club context ID.
 * @param {boolean} [isAFLW] - Whether context is AFLW.
 * @returns {Promise<string>} The resolved profile link (or empty string if player is invalid).
 */
export const fetchPlayerProfileLink = async (
    player,
    clubId,
    isAFLW = false
) => {
    if (!player?.playerId) {
        return '';
    }

    // Get player names to cater for different data models
    const firstName = player.firstName ?? player.playerName?.givenName ?? '';
    const surname = player.surname ?? player.playerName?.surname ?? '';

    let pulseId, relativeURL;

    const isPlayerFromDifferentClub =
        PULSE.app.common.url.isPlayerFromDifferentClub(clubId);

    if (isPlayerFromDifferentClub) {
        pulseId = await PULSE.app.common.pulseId.getPlayerAflPulseId(
            player.playerId
        );
        relativeURL = PULSE.app.common.url.getPlayerProfileURL(
            { firstName, surname, id: pulseId },
            isAFLW
        );

        let pathname = relativeURL;

        if (relativeURL.startsWith('http')) {
            const parsedUrl = new URL(relativeURL);
            pathname = parsedUrl.pathname;
        }

        if (isAFLW && pathname.startsWith('/players/aflw/')) {
            pathname = pathname.replace('/players/aflw/', '/aflw/players/');
        }

        return `${window.AFLM_URL}${pathname}`;
    }

    pulseId = await PULSE.app.common.pulseId.getPlayerPulseId(player.playerId);

    relativeURL = PULSE.app.common.url.getPlayerProfileURL(
        { firstName, surname, id: pulseId },
        isAFLW
    );

    return relativeURL;
};
